module.exports = "/packs/016-b828c7fa3808e362eed7b78cf0d276f1.jpg";